import type { TMessages } from '@/types/TMessages'

export const messages = { header: 'Публикации по теме' } satisfies TMessages
